import { render } from "./FilterTokoCurahByDistributor.vue?vue&type=template&id=9ccbe2be"
import script from "./FilterTokoCurahByDistributor.vue?vue&type=script&lang=js"
export * from "./FilterTokoCurahByDistributor.vue?vue&type=script&lang=js"
script.render = render

export default script